module.exports = __webpack_public_path__ + "static/media/home-product-one.32d02dc4.png";